import {SimpleDropdown} from '@di-nxt/components';
import {IconNames} from '@di-nxt/components/src/components/icons/types';
import React, {useMemo, useCallback, useState} from 'react';
import {t} from '../../../../localization';
import {Absence, useAbsenceTypes} from '../../../../services';

type Props = {
  absence: Absence | undefined;
  onAbsenceTypeChanged: (memberId: number | undefined) => void;
};

export const AbsenceTypeEditor: React.FC<Props> = ({
  absence,
  onAbsenceTypeChanged,
}) => {
  // State
  const [absenceTypeId, setAbsenceTypeId] = useState<number | undefined>(
    absence?.typeId,
  );

  // Data
  const absenceTypes = useAbsenceTypes();
  const types = useMemo(() => absenceTypes.map(at => at.name), [absenceTypes]);
  const icons = useMemo(
    (): IconNames[] => absenceTypes.map(at => at.iconName as IconNames),
    [absenceTypes],
  );

  // Handlers
  const handleChanged = useCallback(
    (index: number | undefined) => {
      const id = index === undefined ? undefined : absenceTypes[index].id;
      setAbsenceTypeId(id);
      onAbsenceTypeChanged(id);
    },
    [absenceTypes, onAbsenceTypeChanged],
  );

  // Render
  return (
    <SimpleDropdown
      items={types}
      icons={icons}
      onSelectedIndexChange={handleChanged}
      selectedIndex={absenceTypes.findIndex(at => at.id === absenceTypeId)}
      placeholder={t('screens.schedule.absencedialog.abscencetype.placeholder')}
    />
  );
};
